import { authRequest } from './api/auth';

class UpGPTDataService {
    getSettingData() {
        // return authRequest.get(`/chatgpt/setbasicsetting/`);
        return authRequest.get(`/upgpt/v2/setting/basic/`);
    }

    setSettingData(data) {
        // return authRequest.post(`/chatgpt/setbasicsetting/`,data);
        return authRequest.post(`/upgpt/v2/setting/basic/`,data);
    }

    reloadChroma_db() {
        return authRequest.post(`/chatgpt/reloaddb_from_admin/`);
    }
    
    resetAllKnowledge() {
        return authRequest.post(`/chatgpt/resetallknowledge/`);
    }

    uploadQAfile(file) {
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        let formData = new FormData();
        formData.append('file', file);
        return authRequest.post(`/chatgpt/uploadqafile/`,formData,config);
    }

    uploadFolder(file) {
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        let formData = new FormData();
        formData.append('file', file);
        return authRequest.post(`/chatgpt/uploadfolder/`,formData,config);
    }

    uploadFile(file) {
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        let formData = new FormData();
        formData.append('file', file);
        return authRequest.post(`/chatgpt/uploadfile/`,formData,config);
    }

    getKnowledgeInfo() {
        return authRequest.post(`/chatgpt/getknowledgeinfo/`);
    }

    downloadtxt(filename) {
        return authRequest.post(`/chatgpt/downloadtxt/`,filename);
    }

    getPromptSettingData() {
        // return authRequest.get(`/chatgpt/promptsetting`);
        return authRequest.get(`/upgpt/v2/setting/prompt/`);
    }

    setPromptSettingData(data) {
        // return authRequest.post(`/chatgpt/promptsetting`,data);
        return authRequest.post(`/upgpt/v2/setting/prompt/`,data);
    }

    getWebsitesSettingData() {
        // return authRequest.get(`/chatgpt/setwebsitessetting/`);
        return authRequest.get(`/upgpt/v2/web/setwebsitessetting/`);
    }

    setWebsitesSettingData(data) {
        // return authRequest.post(`/chatgpt/setwebsitessetting/`,data);
        return authRequest.post(`/upgpt/v2/web/setwebsitessetting/`,data);
    }

    updateWebsitesSettingData(id,data) {
        // return authRequest.put(`/chatgpt/setwebsitessetting/${id}`,data);
        return authRequest.put(`/upgpt/v2/web/setwebsitessetting/${id}`,data);
    } 

    deleteWebsitesSettingData(id) {
        // return authRequest.delete(`/chatgpt/setwebsitessetting/${id}/`);
        return authRequest.delete(`/upgpt/v2/web/setwebsitessetting/${id}`);
    }
    
    downloadwebzip() {
        // return authRequest.post(`/chatgpt/downloadwebzip/`);
        return authRequest.post(`/upgpt/v2/web/downloadwebzip/`);
    }

    websiteanalysis() {
        // return authRequest.post(`/chatgpt/websiteanalysis`);
        return authRequest.post(`/upgpt/v2/web/websiteanalysis/`);
    } 
    campaign_message_generate(data) {
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        return authRequest.post(`/chatgpt/openai/generate_campaign_content/`,data,config);
    }
    get_campaign_message(data) {
        return authRequest.post(`/chatgpt/openai/get_campaign_content/`,data,);
    }
    save_or_undo_campaign_message(data) {
        return authRequest.post(`/chatgpt/openai/save_and_undo_campaign_content/`,data,);
    }
    get_total_statistics(){
        return authRequest.get(`/upgpt/v2/eval/totalstats/`);
    }
    get_all_distinct_topic(){
        return authRequest.get(`/upgpt/v2/eval/topiclist`);
    }
    get_topics_statistics_by_topic(data){
        return authRequest.post(`/upgpt/v2/eval/messagestats/`,data);
    }
    get_questions_statistics_by_topic(data){
        return authRequest.post(`/upgpt/v2/eval/questiondetail/`,data);
    }
    get_question_refence_by_question(data){
        return authRequest.post(`/upgpt/v2/eval/referencedetail/`,data);
    }
}
export default new UpGPTDataService();